<template>
  <div class="complex-text">
    <label slot="label" v-if="disabled" v-html="`${inputCard.label.content}${inputCard.label.icon_msg ? `(${inputCard.label.icon_msg})`:''}`"></label>
    <div v-for="col,index in input" :key="col.toString()+index">
      <template v-for="item,i in textPattern">
        <el-input v-if="item.type=='input'" :value="col[i]" :style="{ width: getWidth }" :placeholder="item.value" @change="change($event,index,i)" :disabled="disabled"></el-input>
        <span v-else style="margin-right: 5px;">{{ item.value }}</span>
      </template>
      <i v-if="index!==0&&!disabled" @click="remove(index)" class="el-icon-delete" style="cursor: pointer;"></i>
    </div>
    <div v-if="fieldSecType==2" style="line-height: 18px;">
      <el-button type="text" icon="el-icon-plus" @click="add" style="padding: 0;" :disabled="disabled">{{ "新增"+inputCard.label.content }}</el-button>
    </div>
  </div>
</template>
<script>
import { getData } from "../../utils/utils";
export default {
  name: "complex-text",
  components: {
 
  },
  props: {
    value: [Array,String],
    inputKey: String,
    inputCard: Object,
    disabled:Boolean
  },
  watch: {
    
  },
  data() {
    return {
      textPattern: [
        // { 'type': 'input', 'value': '测试' }, { 'type': 'text', 'value': '饰演' }, { 'type': 'input', 'value': '请输入' }
      ],
      fieldSecType:1,//1，单条文本，2连续文本
      input: [[]],
    };
  },
  created() {
    const fieldId = this.inputCard.options.fieldId
    this.fieldSecType = this.inputCard.options.fieldSecType || 2
    if (this.value) {
      this.input = this.value
    }
    if (fieldId) {
      const params={fieldId}
      if (this.$route.query['loginParam']) {
        params.loginParam=this.$route.query['loginParam']
      }
      getData('/api/field/config/superText', params,
        (res) => {
          // console.log('res', res,res.data.replaceAll('"','').replaceAll("'",'"'))
        if (res.code == 0 && res.data) {
          this.textPattern = eval(res.data)
          if (!(this.input[0].some(v=>!!v))) {
            this.input = [this.textPattern.map(item=>'')]
          }
        }
      })
    }
    
  },
  computed: {
    getWidth() {
      const col =this.textPattern.filter(item=>item.type=='input').length
      const per = ((1 / col) * 460) 
      const fix = this.textPattern.filter(item => item.type == 'text').map(item => item.value).join('').length * 10  
      return Math.max((per - fix),80)+'px'
    }
  },
  methods: {
    add() {
      const value =this.textPattern.map(item=>'')
      this.input.push(value)
      this.$emit("change", { key:this.inputKey,value:this.input })
    },
    remove(index) {
      this.input.splice(index, 1)
      this.$emit("change", { key:this.inputKey,value:this.input })
    },
    change(val,col,index) {
      this.$set(this.input[col], index, val)
      this.$emit("change", { key:this.inputKey,value:this.input })
    }
  }
};
</script>
<style >
 .pad28 .complex-text .el-input{
  margin-right: 5px;
  margin-bottom: 5px;
 }
 .pad28 .complex-text input{
  width:inherit;
 }
</style>



// WEBPACK FOOTER //
// src/components/form/ComplexText.vue